import { createTheme } from '@mui/material/styles';

import breakpoints from 'utils/breakpoints';
import { getColor } from 'utils/colors';
import mixins from 'utils/mixins';
import { remCalc } from 'utils/remCalc';

const theme = createTheme({
	breakpoints: breakpoints,
	mixins: mixins,
});

export const overrides = {
	'.textSlider__section': {
		...theme.mixins.layout_styles,
		paddingTop: remCalc('60px'),
		color: getColor('ivory', 600),
		'.textSlider__title': {
			textAlign: 'center',
			textTransform: 'uppercase',
			marginBottom: remCalc('80px'),
		},
		'.textSlider': {
			'.textSlider__slide': {
				'.textSlider__inner': {
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'center',
					textAlign:'center',
					gap: remCalc('30px'),
					'.textSlider__slide_title': {
						fontWeight: 400,
					},
					'.textSlider__slide_description': {
						fontWeight: 500,
						fontFamily: 'var(--body-font)',
						[theme.breakpoints.up('md')]: {
							padding: remCalc('0 20px'),
						},
					}
				}
			}
		},
		'.textSlider__pagination': {
			width: '100%',
			paddingTop: remCalc('40px'),
			'.textSlider__bullets': {
				display: 'flex',
				flexDirection: 'row',
				transition: '300ms opacity',
				transform: 'translate3d(0, 0, 0)',
				zIndex: '10',
				'.textSlider__bullet': {
					flex: 'auto',
					height: remCalc(4),
					background: getColor('ivory',400),
					transition: 'all .2s',
					border: 'none',
					[theme.breakpoints.up('lg')]: {
						'&:hover': {
							cursor: 'pointer',
						}
					},
					'&.textSlider__bullet-active': {
						background: getColor('ivory',600),
					}
				}
			}
		},
	}
}

const styles = {};

export default styles;